import React from 'react';

// Static <style> block used by the GuestMapPage. Extracted into its own
// component so the orchestrator file stays readable. `isDarkMode` is
// interpolated into the maplibre canvas fallback background colour.
export function GuestMapStylesheet({ isDarkMode }) {
  return (
    <style>{`
      .maplibregl-map {
        font-family: 'Inria Serif', serif;
        background: ${isDarkMode ? '#10131E' : '#F7F5FC'};
      }
      .maplibregl-canvas {
        outline: none;
      }
      [data-testid='guest-map-canvas'] {
        border-radius: 30px;
        overflow: hidden;
        clip-path: inset(0 round 30px);
      }
      .maplibregl-canvas-container,
      .maplibregl-canvas {
        border-radius: 30px;
      }
      .maplibregl-ctrl-bottom-right,
      .maplibregl-ctrl-bottom-left,
      .maplibregl-ctrl-top-right,
      .maplibregl-ctrl-top-left {
        display: none !important;
      }
      /* NEVER set position here. MapLibre anchors every marker with
         .maplibregl-marker { position: absolute } + a translate()
         transform. In the production bundle this style block is parsed
         AFTER the extracted maplibre CSS, so a position: relative override
         pulled every venue pin into normal flow and the pins stacked into
         a vertical column (offsetTop 0/46/92...) on the live app only. */
      [data-testid^='map-marker-'] {
        z-index: 2;
      }
      @keyframes allure-map-marker-glow {
        0%, 100% { transform: scale(0.96); opacity: 0.72; }
        50% { transform: scale(1.08); opacity: 1; }
      }
      @keyframes allure-event-glow-live {
        0%, 100% { transform: scale(0.92); opacity: 0.85; }
        50% { transform: scale(1.18); opacity: 1; }
      }
      @keyframes allure-event-glow-starting {
        0%, 100% { transform: scale(0.94); opacity: 0.55; }
        50% { transform: scale(1.10); opacity: 0.85; }
      }
      @keyframes allure-user-location-pulse {
        0%   { transform: scale(0.85); opacity: 0.85; }
        70%  { transform: scale(1.6);  opacity: 0; }
        100% { transform: scale(1.6);  opacity: 0; }
      }
      @keyframes map-shimmer-pulse {
        0% { background-position: -200px 0; }
        100% { background-position: calc(200px + 100%) 0; }
      }
      .map-shimmer {
        background-color: #ECE8F6;
        background-image: linear-gradient(90deg, #ECE8F6 0px, #F6F3FF 80px, #ECE8F6 160px);
        background-size: 240px 100%;
        background-repeat: no-repeat;
        animation: map-shimmer-pulse 1.4s ease-in-out infinite;
      }
      /* Fired for ~1.1s on the maplibre marker INNER wrapper elements
         ([data-marker-inner]) that match a newly-selected tag.
         Applying this to the inner wrapper keeps maplibre's outer
         translate() positioning intact — the pin pulses in place
         instead of snapping to the top-left corner of the map. */
      @keyframes allure-tag-pin-pulse {
        0%   { transform: scale(1);    filter: drop-shadow(0 0 0 rgba(124,58,237,0)); }
        30%  { transform: scale(1.28); filter: drop-shadow(0 6px 16px rgba(124,58,237,0.85)); }
        55%  { transform: scale(0.96); filter: drop-shadow(0 3px 8px rgba(124,58,237,0.35)); }
        80%  { transform: scale(1.12); filter: drop-shadow(0 4px 12px rgba(124,58,237,0.55)); }
        100% { transform: scale(1);    filter: drop-shadow(0 0 0 rgba(124,58,237,0)); }
      }
      .allure-tag-pin-pulse {
        animation: allure-tag-pin-pulse 1100ms cubic-bezier(.34,1.56,.64,1) 1;
        transform-origin: center center;
        z-index: 5 !important;
      }
    `}</style>
  );
}
